import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';

import Layout from '@ro-components/Layout';
import CustomPaper from '@ro-atoms/CustomPaper';
import ContentText from '@ro-atoms/ContentText';
import Icon from '@ro-atoms/Icon';

const TextBlock = styled.div`
  padding: 10px 0;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
`;

type Props = {
  customCloseAction: () => void;
  acceptAndClose: () => void;
  intl: any;
};

class InProgress extends Component<Props> {
  render() {
    const { customCloseAction, acceptAndClose } = this.props;
    return (
      <Layout alpha={0.8} noBack customCloseAction={customCloseAction}>
        {
          <CustomPaper elevation={9} alpha={1}>
            <>
              <TextBlock>
                <ContentText offset="15">
                  <>
                    Cześć. Nowa wersja RO oferuje znacznie więcej. Zdajemy sobie jednak sprawę z tego jak silne mogą być
                    przyzwyczajenia. Polecamy więc spokojne testowanie nowej wersji mając pod ręką starą wersję radaru
                    opadów - nic na siłę :) Po przeczytaniu i zaakceptowaniu tej wiadomości będziesz mógł uruchomić
                    poprzednią wersję radaru kilkając w ikonkę v.1. w zbiorze kontrolek z prawej strony ekranu.
                    <br />
                    <br />
                    <Button color="primary" variant="contained" onClick={acceptAndClose}>
                      Zaakceptuj i nie pokazuj więcej
                      <Icon name="checked fas" />
                    </Button>{' '}
                    <Button color="secondary" variant="contained" onClick={customCloseAction}>
                      Zamknij
                      <Icon name="checked fas" />
                    </Button>
                  </>
                </ContentText>
              </TextBlock>
            </>
          </CustomPaper>
        }
      </Layout>
    );
  }
}

export default InProgress;
